export default __webpack_public_path__ + "static/add@mob-67bbf139d1f286ec1074a239fc271fe0.svg";